// extracted by mini-css-extract-plugin
module.exports = {"tests-page-wrapper":"TestsPage_tests-page-wrapper__2QPZ2"};